import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TransactionListPageComponent} from './transaction-list-page.component';
import {RouterModule} from '@angular/router';
import {CmsPageGuard} from '@spartacus/storefront';
import {AuthGuard} from '@spartacus/core';
import {FormsModule} from '@angular/forms';

import {ClipboardModule} from '@angular/cdk/clipboard';
import {CartEditModule} from '@app/cart/edit-cart/cart-edit.module';
import {LoadingPageComponent} from '@dcp/configurator';
import '@sapudex/web-components/dist/Table.js';
import '@sapudex/web-components/dist/TableHeaderRow.js';
import '@sapudex/web-components/dist/TableHeaderCell.js';
import '@sapudex/web-components/dist/TableRow.js';
import '@sapudex/web-components/dist/TableCell.js';
import '@sapudex/web-components/dist/TableGroupRow.js';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: 'test/transactions',
        component: TransactionListPageComponent,
        canActivate: [CmsPageGuard, AuthGuard],
      },
    ]),
    FormsModule,
    ClipboardModule,
    CartEditModule,
    LoadingPageComponent,
    TransactionListPageComponent,
  ],
  exports: [RouterModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TransactionListPageModule {}
